import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import Modal from '../../../../../family-maker/client/components/Modal';

export default class QuantityInput extends Component {
  static propTypes = {
    errors: PropTypes.array,
    handleChange: PropTypes.func.isRequired,
    quantity: PropTypes.number.isRequired,
    sizeChart: PropTypes.bool
  }

  state = {
    sizeChartModalOpen: false
  }

  render() {
    const { errors, quantity } = this.props;
    const formGroupClasses = classNames({
      'form-group': true,
      'has-error': errors && !!errors.length,
      'product__info__quantity': true
    });

    return (
      <div className="d-flex align-items-center">
        <div className={formGroupClasses}>
          <label className="control-label product__variant-picker__label" htmlFor="id_quantity">{pgettext('Add to cart form field label', 'Quantity')}</label>
          <input
            className="form-control"
            defaultValue={quantity}
            id="id_quantity"
            max="999"
            min="0"
            name="quantity"
            onChange={this.props.handleChange}
            type="number"
          />
          {errors && (
            <span className="help-block">{errors.join(' ')}</span>
          )}
        </div>
        {this.props.sizeChart && (
          <div className="size-chart-links pt-3">
            <p onClick={() => this.setState({ sizeChartModalOpen: true })} className="size-chart-link">See Size Chart</p>
          </div>
        )}
        <Modal
          show={this.state.sizeChartModalOpen}
          close={() => this.setState({ sizeChartModalOpen: false })}
        >
          <img src={this.props.sizeChart} className="full-image" />
        </Modal>
      </div>
    );
  }
}
